import { useAuth } from './AuthProvider';

export const ROLES = {
  ADMIN: 'lft.admin',
  TRAEGER_ADMIN: 'lft.traeger_admin',
  PLANER: 'lft.planer',
  LESEN: 'lft.lesen',
  FIBU: 'lft.fibu',
} as const;

export type LftRole = (typeof ROLES)[keyof typeof ROLES];

export function hasRole(roles: string[], required: LftRole | LftRole[]): boolean {
  const list = Array.isArray(required) ? required : [required];
  return list.some((r) => roles.includes(r));
}

/**
 * Returns true if the current user has at least one of the required roles.
 * Pure check; does not redirect or throw.
 */
export function useHasRole(required: LftRole | LftRole[]): boolean {
  const { roles } = useAuth();
  return hasRole(roles, required);
}

/**
 * Convenience guard for write operations.
 * Read-only role users see disabled buttons.
 */
export function useCanWrite(): boolean {
  const { roles } = useAuth();
  return hasRole(roles, [ROLES.ADMIN, ROLES.TRAEGER_ADMIN, ROLES.PLANER]);
}

export function useIsAdmin(): boolean {
  return useHasRole(ROLES.ADMIN);
}
